(() => {
  function initialize() {
    document.querySelectorAll('.sparkle-pilot').forEach(root => {
      if (root.dataset.metalControlsReady) return;
      const colours = root.querySelector('[data-metal-colours]');
      if (!colours) return;
      root.dataset.metalControlsReady = 'true';
      function update() {
        const selected = root.querySelector('input[name^="pilot-metal"]:checked');
        const platinum = selected?.value === 'Platinum';
        colours.hidden = platinum;
        colours.disabled = platinum;
      }
      root.addEventListener('change', event => {
        if (event.target.matches('input[name^="pilot-metal"]')) update();
      });
      update();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

(() => {
  function initialize() {
    document.querySelectorAll('.sp-contact').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const dialog = section.querySelector('dialog');
      function open(channel) {
        if (typeof dialog.showModal !== 'function') return false;
        dialog.querySelectorAll('[data-qr-panel]').forEach(panel => { panel.hidden = panel.dataset.qrPanel !== channel; });
        dialog.querySelector('[data-contact-dialog-title]').textContent = channel === 'whatsapp' ? 'Connect on WhatsApp' : 'Connect on Messenger';
        dialog.showModal();
        return true;
      }
      section.querySelectorAll('[data-qr-channel]').forEach(button => button.addEventListener('click', () => open(button.dataset.qrChannel)));
      section.querySelectorAll('[data-contact-channel]').forEach(link => link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        if (window.matchMedia('(pointer:fine) and (min-width: 768px)').matches && open(link.dataset.contactChannel)) event.preventDefault();
      }));
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();


(() => {
  function initialize() {
    document.querySelectorAll('.sparkle-pilot').forEach(root => {
      const button = root.querySelector('[data-request-quote]');
      if (!button || button.dataset.ready) return;
      button.dataset.ready = 'true';
      const dialog = root.querySelector('[data-quote-dialog]');
      const message = dialog.querySelector('[data-quote-message]');
      const text = dialog.querySelector('[data-quote-text]');
      const fallback = dialog.querySelector('[data-quote-fallback]');
      const engravingToggle = root.querySelector('[data-engraving-toggle]');
      const engravingInput = root.querySelector('[data-engraving-text]');
      function syncEngraving() {
        const enabled = engravingToggle.checked;
        root.querySelector('[data-engraving-field]').hidden = !enabled;
        engravingInput.disabled = !enabled;
        engravingToggle.setAttribute('aria-expanded', String(enabled));
      }
      if (engravingToggle) {
        engravingToggle.addEventListener('change', syncEngraving);
        syncEngraving();
      }
      function configuration() {
        const metal = root.querySelector('input[name^="pilot-metal"]:checked')?.value || 'Not selected';
        const colour = root.querySelector('input[name="properties[Metal colour]"]:checked')?.value || 'Not selected';
        const lines = ['Hello, I would like a quote for this Sparkle ring.', '', root.querySelector('h1').textContent.trim(), 'Reference: SP-0001-LG', 'Diamond: Lab-grown', 'Centre weight: 2 ct', 'Shape: Round', 'Metal: ' + metal];
        if (metal !== 'Platinum') lines.push('Metal colour: ' + colour);
        const ringSize = root.querySelector('[data-ring-size]')?.value.trim();
        lines.push(ringSize ? 'Ring size (US): ' + ringSize : 'Ring size: Sizing assistance requested');
        if (engravingToggle?.checked) lines.push('Free engraving: ' + (engravingInput.value.trim() || 'Requested — wording to be confirmed'));
        if (location.protocol === 'https:' || location.protocol === 'http:') lines.push('Product: ' + location.origin + location.pathname);
        return lines.join('\n');
      }
      async function copy() {
        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text.value);
            return true;
          }
        } catch (_) { /* Offer the visible manual copy field when access is denied. */ }
        try {
          fallback.hidden = false;
          text.focus();
          text.select();
          return document.execCommand('copy') === true;
        } catch (_) { return false; }
      }
      async function copyAndReport() {
        const success = await copy();
        fallback.hidden = success;
        message.textContent = success ? 'Your selected configuration has been copied. Open WhatsApp and paste it into the chat to request your quote.' : 'Automatic copying is unavailable in this browser. Copy the details below, then open WhatsApp and paste them into the chat.';
        if (success) dialog.querySelector('[data-quote-whatsapp]').focus();
      }
      button.addEventListener('click', async () => {
        text.value = configuration();
        fallback.hidden = true;
        message.textContent = 'Copying your selected configuration…';
        dialog.showModal();
        await copyAndReport();
      });
      dialog.querySelector('[data-quote-copy]').addEventListener('click', copyAndReport);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

(() => {
  function refreshDelivery() {
    const parts = new Intl.DateTimeFormat('en-US', {timeZone:'Asia/Dubai',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date());
    const value = type => Number(parts.find(p => p.type === type).value);
    document.querySelectorAll('[data-delivery-date]').forEach(node => {
      const days = node.getAttribute('data-delivery-date') === 'end' ? 12 : 10;
      const arrival = new Date(Date.UTC(value('year'), value('month') - 1, value('day') + days));
      node.textContent = new Intl.DateTimeFormat('en-US', {timeZone:'UTC',month:'short',day:'numeric'}).format(arrival);
      node.setAttribute('datetime', arrival.toISOString().slice(0,10));
    });
  }
  refreshDelivery();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshDelivery(); });
  document.addEventListener('shopify:section:load', refreshDelivery);
  setInterval(refreshDelivery, 60000);
})();
